import React from 'react';
import PageComponent from "js/components/pages/PageComponent";
import AppUser from "js/stores/AppUser";
import AppContent from "js/components/AppContent";
import {makeRequest, navigate, url} from "js/services/Network";
import Constraint from "js/components/Constraint";
import FormState from 'js/stores/forms/LoginSignupDialogForm';
import { AvForm, AvGroup, AvInput, AvFeedback, AvField } from 'availity-mobx-reactstrap-validation';
import Button from 'js/components/common/Button';
import ErrorDisplay from "js/components/common/ErrorDisplay";

export default class SPPOnboardPartner extends PageComponent {
  constructor(props) {
    super(props);
    this.state = {
      readMore: true,
      media: 'Instagram',
      errorMessage: null,
      pspData: null,
      duration: 'per_day'
    }
  }
  pageName = 'SPPOnboardPartner';
  redirect = (link) => navigate(url(link?link:'psp','',''));

  pageEvent = () => {
    if (AppUser.isLoggedIn){
    }else{
      this.redirect('psp');
    }
  }
  formState = FormState.create();

  partnerSubmitted = (event, errors, formValues) => {
    event.preventDefault();
    this.formState.clearError();
    if (!errors.length && !this.formState.requestInProgress){
      this.formState.setIsRequesting();
      formValues.duration = 'per_day';
      this.formValues = formValues;

      makeRequest('seller-partnership-program-onboard-save', null, formValues)
        .then(response => {
          this.formState.setIsRequesting(false);
          if (response.data && response.data.message) {
            this.formState.setError(response.data.message);
            this.setState({errorMessage: response.data.message})
          } else if (response.data && response.data.data) {
            this.setState({pspData: response.data.data});
            this.redirect('psp-onboard-success');
          }
        })
        .catch(error => {
          this.formState.setIsRequesting(false);
          if (error.response && error.response.data && error.response.data.message) {
            this.formState.setError(error.response.data.message);
            this.setState({errorMessage: error.response.data.message})
          }else{
            this.formState.setError('An error occurred');
            this.setState({errorMessage: 'An error occurred'})
          }
        })
    }
  }

  flip = () => {
    let cd = document.getElementsByClassName("carded")
    cd.toggleClass('flipped');
  }


  renderPage() {
    const { error, requestInProgress, showForgotPassword } = this.formState;

    let carded = document.querySelectorAll('.card');


    [...carded].forEach((card)=>{
      card.addEventListener( 'click', function() {
        // console.log("I got clicked!")
        card.classList.toggle('is-flipped');
      });
    });

    return (
      <AppContent className="seller-link-page" padded>
        <div className="pod-container">
          <div className="d-flex flex-column flex-md-row justify-content-between">
            <div className="store-container">
              <div className="">
                <h6 className="tw-font-semibold tw-text-2xl tw-text-primary">
                  Welcome shop {AppUser.login}
                </h6>
                <p className="tw-text-sm tw-mt-3">
            <span className="tw-text-[#2C353CB2]">
              Sign up for the POD seller partnership program.{" "}
            </span>
                </p>
              </div>
              <div className="tw-max-w-xl tw-mx-auto tw-mt-12">
                <AvForm className="tw-w-full" onSubmit={this.partnerSubmitted}>
                  <AvGroup className="tw-w-full">
                    <label
                      htmlFor="password"
                      className="tw-block tw-mb-2 tw-text-base tw-font-medium tw-text-primary">
                      Where do you sell
                    </label>
                    <AvField type="select" id="media" name="media" helpMessage="Select your most active social media platform"
                             className="tw-bg-white tw-border tw-border-outline tw-placeholder-[#6C7277] tw-text-[#6C7277] tw-font-medium tw-text-sm tw-rounded-lg tw-block tw-w-full tw-pr-8 tw-p-3"
                      onChange={(e) => this.setState({ media: e.target.value })} required>
                      <option className="text-muted" disabled value="">
                         Selec t
                      </option>
                      <option value="Instagram">Instagram</option>
                      <option value="Facebook">Facebook</option>
                      <option value="X">X</option>
                      <option value="Snapchat">Snapchat</option>
                    </AvField>
                    <AvFeedback>Please select where you do sell</AvFeedback>
                  </AvGroup>
                  <AvGroup className="tw-w-full tw-mt-6">
                    <label
                      htmlFor="tw-instagram-handle"
                      className="tw-block tw-mb-2 tw-text-base tw-font-medium tw-text-primary">
                      {this.state.media} handle
                    </label>
                    <AvInput
                      type="text"
                      name="handle"
                      id="tw-instagram-handle"
                      required
                      aria-describedby="tw-helper-text-explanation"
                      className="tw-bg-white tw-border tw-border-outline tw-placeholder-[#6C7277] tw-text-primary tw-font-medium tw-text-sm tw-rounded-lg tw-w-full tw-p-3"
                      placeholder={"Type your business " + this.state.media + " handle"}
                    />
                    <AvFeedback>Please enter your valid social media handle</AvFeedback>
                  </AvGroup>
                  <AvGroup className="tw-w-full tw-mt-6">
                    <label
                      htmlFor="followers"
                      className="tw-block tw-mb-2 tw-text-base tw-font-medium tw-text-primary">
                      Number of followers
                    </label>
                    <AvInput
                      type="text"
                      name="followers"
                      required
                      id="followers"
                      aria-describedby="tw-helper-text-explanation"
                      className="tw-bg-white tw-border tw-border-outline tw-placeholder-[#6C7277] tw-text-primary tw-font-medium tw-text-sm tw-rounded-lg tw-w-full tw-p-3"
                      placeholder={"Enter the number of your "+this.state.media+" followers"}
                    />
                    <AvFeedback>{"Please enter valid "+this.state.media+" followers"}</AvFeedback>
                  </AvGroup>
                  <AvGroup className="tw-w-full tw-mt-6">
                    <label
                      htmlFor="followers"
                      className="tw-block tw-mb-2 tw-text-base tw-font-medium tw-text-primary">
                      Number of transactions
                    </label>
                    <div className="tw-flex tw-items-center tw-gap-6">
                      <AvInput
                        type="text"
                        name="transaction_count"
                        id="followers"
                        aria-describedby="tw-helper-text-explanation"
                        className="tw-bg-white tw-border tw-border-outline tw-placeholder-[#6C7277] tw-text-primary tw-font-medium tw-text-sm tw-rounded-lg tw-w-full tw-p-3 tw-basis-3/4"
                        placeholder="Enter transaction count"
                      />
                      <AvField
                        type="select"
                        id="duration"
                        name="duration"
                        defaultValue={this.state.duration}
                        required
                        disabled
                        className="tw-bg-white tw-border tw-border-outline tw-placeholder-[#6C7277] tw-text-[#6C7277] tw-font-medium tw-text-sm tw-rounded-lg tw-block tw-w-full tw-pr-8 tw-p-3 tw-mt-4">
                        <option value="per_day">Per day</option>
                        <option value="per_week">Per week</option>
                        <option value="per_month">Per month</option>
                        <option value="per_year">Per year</option>
                      </AvField>
                      <AvFeedback>Please select frequency</AvFeedback>
                    </div>
                    <AvInput
                      type="hidden"
                      name="seller_id"
                      id="seller_id"
                      value={AppUser.id}
                      aria-describedby="tw-helper-text-explanation"
                      className="tw-bg-white tw-border tw-border-outline tw-placeholder-[#6C7277] tw-text-primary tw-font-medium tw-text-sm tw-rounded-lg tw-w-full tw-p-3"
                    />
                  </AvGroup>
                  <Button className="tw-bg-secondary tw-py-3 tw-w-full tw-rounded-lg tw-mt-10"
                          isLoading={requestInProgress} type="submit">
                    {'Sign up as a seller partner'}
                    {/*<Link href={"/success"} className="tw-text-white tw-font-semibold" to={''}>*/}
                    {/*  Sign up as a seller partner*/}
                    {/*</Link>*/}
                  </Button>
                  <ErrorDisplay>{this.state.errorMessage}</ErrorDisplay>
                </AvForm>
              </div>
            </div>
            <div className="added-item sm:tw-mt-10">
              {this.state.readMore ? (
                <div
                  className="card carded tw-rounded-3xl tw-bg-primary tw-max-h-[90vh] tw-mb-16 tw-md:tw-mb-0 tw-text-white tw-rounded-[30px] tw-overflow-hidden tw-relative">
                  <style jsx>{`
                  .flipped {
                    transform: rotateY(180deg);
                   }
              `}</style>
                  <div
                    className="tw-bg-[#FDAE09] size-55px tw-rounded-full tw-absolute tw-top-[-34px] tw-right-3 tw-hidden tw-md:tw-block"></div>
                  <div className="tw-md:tw-flex tw-my-6 tw-px-10 tw-hidden">
                    <span className="tw-block tw-bg-[#FDAE09] size-8px tw-rounded-full"></span>
                  </div>
                  <div className="tw-md:tw-px-12 tw-px-6 tw-py-8">
                    <h2 className="tw-text-xl">POD seller partner program</h2>
                    <p className="tw-text-sm tw-text-faint tw-mt-3">
                      Get accurate and updated live rates of over 38+
                      currencies, perform instant exchange, forward rate or quick
                      currency conversion.
                    </p>
                    <div className="tw-mt-12">
                      <div className="tw-flex tw-items-center tw-gap-4">
                        <img
                          src="/images/icons/icon-right.png"
                          alt="icon-right"
                          className="tw-w-[10px] tw-h-[6.66px]"
                        />
                        <p className="tw-text-sm tw-text-faint">Revenue sharing</p>
                      </div>
                      <div className="tw-flex tw-items-center tw-gap-4 tw-mt-4">
                        <img
                          src="/images/icons/icon-right.png"
                          alt="icon-right"
                          className="tw-w-[10px] tw-h-[6.66px]"
                        />
                        <p className="tw-text-sm tw-text-faint">
                          Sell more, make more money
                        </p>
                      </div>
                      <div className="tw-flex tw-items-center tw-gap-4 tw-mt-4">
                        <img
                          src="/images/icons/icon-right.png"
                          alt="icon-right"
                          className="tw-w-[10px] tw-h-[6.66px]"
                        />
                        <p className="tw-text-sm tw-text-faint">invite only</p>
                      </div>
                    </div>
                    <div className="tw-flex tw-justify-end tw-md:tw-justify-start tw-gap-4">
                      {/*<button className="tw-bg-secondary tw-py-3 tw-rounded-lg tw-mt-8 tw-px-2.5 tw-float-left"*/}
                      {/*  onClick={() => navigate(url('psp-seller','',''))}>*/}
                      {/*  <span className="tw-text-sm tw-font-semibold tw-text-white">View store</span>*/}
                      {/*</button>*/}
                      <button
                        className="tw-rounded-lg tw-border tw-border-white tw-py-2 tw-px-2.5 tw-mt-8"
                        onClick={() => this.setState({ readMore: !this.state.readMore })}>
                        <span className="tw-text-sm tw-font-semibold tw-animate-spin">learn more</span>
                      </button>
                    </div>
                  </div>
                  <div className="tw-md:flex tw-justify-end tw-mb-10 tw-px-10 tw-hidden">
                    <span className="tw-block tw-bg-[#AAD7E1] size-10px tw-rounded-full"></span>
                  </div>
                  <div>
                    <img
                      src="/images/ssp/bg-desktop2.png"
                      alt="bg-desktop"
                      className="tw-w-full tw-h-[300px] tw-object-cover tw-hidden tw-md:tw-block"
                    />
                    <img
                      src="/images/ssp/bg-mobile2.png"
                      alt="bg-desktop"
                      className="tw-w-full tw-h-[100px] tw-object-cover tw-md:tw-hidden"
                    />
                  </div>
                </div>
              ) : (
                <div
                  className="card carded tw-rounded-3xl tw-bg-primary tw-pt-3 tw-max-h-[90vh] tw-mb-16 tw-md:mb-0 tw-text-white tw-rounded-[30px] tw-overflow-hidden tw-relative">
                  <style jsx>{`
                  .flipped {
                    transform: rotateY(180deg);
                   }
              `}</style>
                  <div
                    className="tw-bg-[#FDAE09] size-55px tw-rounded-full tw-absolute tw-top-[-24px] tw-right-[-10px] tw-hidden tw-md:tw-block"></div>
                  <div className="tw-md:tw-px-12 tw-px-6 tw-py-8 tw-max-h-[70vh] tw-overflow-y-scroll">
                    <style jsx>{`
                ::-webkit-scrollbar {
                  width: 6px;
                }

                ::-webkit-scrollbar-track {
                  background: transparent;
                  border-radius: 30px;
                }

                ::-webkit-scrollbar-thumb {
                  background: #6d60f6;
                  border-radius: 30px;
                }

                ::-webkit-scrollbar-button {
                  display: none;
                }
              `}</style>
                    <p className="tw-text-sm tw-text-faint">
                      Welcome to the POD Partnership Program, where your success is
                      our priority! Joining our program opens up a world of
                      opportunities to take your business to new heights. Here's what
                      you need to know:
                    </p>
                    <div className="tw-mt-8">
                      <p className="tw-text-base tw-text-faint tw-mb-6">
                        What is the POD Partnership Program?
                      </p>
                      <p className="tw-text-sm tw-text-faint tw-mt-3">
                        The POD Partnership Program is a unique opportunity for
                        sellers like you to earn additional income by referring
                        businesses to join POD. As they sign up and start selling
                        through POD, you'll earn a percentage of the revenue
                        generated.
                      </p>
                    </div>
                    <div className="tw-mt-12">
                      <p className="tw-text-base tw-text-faint tw-mt-6 tw-mb-6">
                        Why join the POD Partnership Program?
                      </p>
                      <div className="tw-flex tw-items-center tw-gap-4">
                        <span className="tw-block tw-w-1 tw-h-1 tw-bg-faint tw-rounded-full"></span>
                        <p className="tw-text-sm tw-text-faint">
                          Boost Your Earnings: Earn extra income simply by sharing
                          your unique referral link with other businesses.
                        </p>
                      </div>
                      <div className="tw-flex tw-items-center tw-gap-4 tw-mt-4">
                        <span className="tw-block tw-w-1 tw-h-1 tw-bg-faint tw-rounded-full"></span>
                        <p className="tw-text-sm tw-text-faint">
                          Empowerment: Take control of your financial future and
                          unlock new revenue streams.
                        </p>
                      </div>
                      <div className="tw-flex tw-items-center tw-gap-4 tw-mt-4">
                        <span className="tw-block tw-w-1 tw-h-1 tw-bg-faint tw-rounded-full"></span>
                        <p className="tw-text-sm tw-text-faint">
                          Support: Receive dedicated support from the POD team to help
                          you succeed in the program.
                        </p>
                      </div>
                      <div className="tw-flex tw-items-center tw-gap-4 tw-mt-4">
                        <span className="tw-block tw-w-1 tw-h-1 tw-bg-faint tw-rounded-full"></span>
                        <p className="tw-text-sm tw-text-faint">
                          Flexibility: Work at your own pace and fit the program into
                          your existing schedule.
                        </p>
                      </div>
                    </div>

                    <div className="tw-mt-12">
                      <p className="tw-text-base tw-text-faint tw-mt-6 tw-mb-6">
                        How Does it Work?
                      </p>
                      <div className="tw-flex tw-items-center tw-gap-4">
                        <span className="tw-block tw-w-1 tw-h-1 tw-bg-faint tw-rounded-full"></span>
                        <p className="tw-text-sm tw-text-faint">
                          Sign up for the POD Partnership Program.
                        </p>
                      </div>
                      <div className="tw-flex tw-items-center tw-gap-4 tw-mt-4">
                        <span className="tw-block tw-w-1 tw-h-1 tw-bg-faint tw-rounded-full"></span>
                        <p className="tw-text-sm tw-text-faint">
                          Receive your unique referral link.
                        </p>
                      </div>
                      <div className="tw-flex tw-items-center tw-gap-4 tw-mt-4">
                        <span className="tw-block tw-w-1 tw-h-1 tw-bg-faint tw-rounded-full"></span>
                        <p className="tw-text-sm tw-text-faint">
                          Share your link with other businesses.
                        </p>
                      </div>
                      <div className="tw-flex tw-items-center tw-gap-4 tw-mt-4">
                        <span className="tw-block tw-w-1 tw-h-1 tw-bg-faint tw-rounded-full"></span>
                        <p className="tw-text-sm tw-text-faint">
                          Earn a percentage of the revenue generated by the businesses
                          you refer.
                        </p>
                      </div>
                    </div>

                    <div className="tw-mt-6">
                      <p className="tw-text-sm tw-text-faint tw-mt-3">
                        Ready to Get Started? Joining the POD Partnership Program is
                        quick and easy. Simply sign up, start sharing your referral
                        link, and watch your earnings grow! Sign Up Now and Start
                        Earning!
                      </p>
                    </div>
                  </div>

                  <div className="tw-mb-10 tw-px-10">
                    <div className="tw-flex tw-justify-end">
                      <button
                        className="tw-rounded-lg tw-border tw-border-white tw-py-2 tw-px-2.5 tw-mt-8"
                        onClick={() => this.setState({ readMore: !this.state.readMore })}>
                        <span className="tw-text-sm tw-font-semibold">Okay, Got it</span>
                      </button>
                    </div>
                    <span className="tw-block tw-bg-[#AAD7E1] size-10px tw-rounded-full"></span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </AppContent>
    )
  }
}
